import type { BookingVehicle, VehicleSummary } from '@/types'

import { normalizeText } from '@/lib/text'

/*
 * Pure helpers that are safe in the browser. Anything that talks to the
 * database lives in @/lib/vehicles instead.
 */

export type PowertrainKind = 'electric' | 'hybrid'

export const toBookingVehicle = (vehicle: BookingVehicle): BookingVehicle => ({
    id: vehicle.id,
    marca: vehicle.marca,
    modelo: vehicle.modelo,
    pasajeros: vehicle.pasajeros
})

export const getVehicleName = (vehicle: Pick<VehicleSummary, 'marca' | 'modelo'>): string => {
    return `${vehicle.marca} ${vehicle.modelo}`.trim()
}

export const getPowertrainKind = (motorizacion: string | null): PowertrainKind | null => {
    if (!motorizacion) return null

    const value = normalizeText(motorizacion)

    if (value.includes('electr')) return 'electric'
    if (value.includes('hibrid')) return 'hybrid'

    return null
}

export const sortByRecommendation = (a: VehicleSummary, b: VehicleSummary): number => {
    if (a.destacado !== b.destacado) return a.destacado ? -1 : 1
    if (a.orden !== b.orden) return a.orden - b.orden

    return getVehicleName(a).localeCompare(getVehicleName(b), 'es')
}

// Other vehicles to suggest on a detail page: same category first, then the recommended order.
export const pickRelatedVehicles = (current: VehicleSummary, fleet: Array<VehicleSummary>, limit: number): Array<VehicleSummary> => {
    return fleet
        .filter(vehicle => vehicle.id !== current.id)
        .sort((a, b) => {
            const aSame = a.categoria === current.categoria ? 0 : 1
            const bSame = b.categoria === current.categoria ? 0 : 1

            return aSame - bSame || sortByRecommendation(a, b)
        })
        .slice(0, limit)
}
